export default "__VITE_ASSET__DrXivsP4__"